import React, { ReactElement, useEffect } from "react";
import { useDispatch } from "react-redux";
import { bulkUpdatePorAsins, updatePorAsin } from "./porAsinListSlice";
import { DatePicker, Input } from "@amzn/awsui-components-react/polaris";
import { DATE_FORMAT_LENGTH, serviceToDisplayUTC } from "../../util/dateUtils";
import { FullAsin } from "../../server/asin-central/model";

export interface EditableCellProps {
  isHeader?: boolean;
  placeholder?: string;
  item?: FullAsin;
}

export interface EditDatePickerProps {
  id: "announceDate" | "onlineStreetDate";
}

export const EditDatePicker = (
  props: EditDatePickerProps & EditableCellProps
): ReactElement => {
  const dispatch = useDispatch();
  const dateValue = props.item ? props.item[props.id] : undefined;
  const [value, setValue] = React.useState(
    dateValue ? serviceToDisplayUTC(dateValue, "yyyy-MM-DD") : ""
  );
  useEffect(() => {
    setValue(dateValue ? serviceToDisplayUTC(dateValue, "yyyy-MM-DD") : "");
  }, [dateValue]);

  return (
    <DatePicker
      value={value}
      onChange={({ detail }): void => {
        if (props.isHeader) {
          dispatch(bulkUpdatePorAsins([props.id, detail.value]));
        } else {
          // Hacky fix to halt date auto formatting in table cell
          if (!detail.value || detail.value.length === DATE_FORMAT_LENGTH) {
            dispatch(updatePorAsin([props.item, props.id, detail.value]));
          }
        }
        setValue(detail.value);
      }}
      todayAriaLabel="Today"
      nextMonthAriaLabel="Next month"
      previousMonthAriaLabel="Previous month"
      expandToViewport={true}
      placeholder={props.placeholder ? props.placeholder : "YYYY/MM/DD"}
      disabled={props.item?.isRestricted}
    />
  );
};

export interface EditTextInputProps {
  id: "userDescription";
}

export const EditTextInput = (
  props: EditTextInputProps & EditableCellProps
): ReactElement => {
  const dispatch = useDispatch();
  const textValue = props.item ? props.item[props.id] ?? "" : "";
  const [value, setValue] = React.useState(textValue);
  useEffect(() => {
    setValue(textValue);
  }, [textValue]);

  return (
    <Input
      onChange={({ detail }): void => {
        if (props.isHeader) {
          dispatch(bulkUpdatePorAsins([props.id, detail.value]));
        } else {
          dispatch(updatePorAsin([props.item, props.id, detail.value]));
        }
        setValue(detail.value);
      }}
      placeholder={props.placeholder}
      value={value}
    />
  );
};
